import { createTheme } from '@mui/material/styles'

// MT Solar Brand Colors
// Primary: Dark Navy Blue - Professional and trustworthy
// Secondary: Bright Cyan - Energetic and modern
// Inspired by mtsolar.co.uk color scheme

const theme = createTheme({
    palette: {
      mode: 'light',
      primary: {
        light: '#3d5a7e',
        main: '#1e3a5f',
        dark: '#152944',
        contrastText: '#fff',
      },
      secondary: {
        light: '#33c4e3',
        main: '#00b8d8',
        dark: '#0091b0',
        contrastText: '#fff',
      },
      // Custom colors for legacy compatibility
      openTitle: '#1e3a5f',
      protectedTitle: '#00b8d8',
    },
    typography: {
      // Smaller default font size
      fontSize: 13,
    },
    components: {
      // Select component overrides
      MuiSelect: {
        styleOverrides: {
          select: {
            fontSize: '12px',
            padding: '6px 10px',
          },
        },
        defaultProps: {
          size: 'small',
        },
      },
      // Input label styling
      MuiInputLabel: {
        styleOverrides: {
          root: {
            fontSize: '12px',
          },
        },
      },
      // MenuItem styling (dropdown options)
      MuiMenuItem: {
        styleOverrides: {
          root: {
            fontSize: '12px',
            minHeight: '32px',
          },
        },
      },
      // FormControl styling
      MuiFormControl: {
        defaultProps: {
          size: 'small',
        },
      },
      // Input/TextField styling
      MuiInputBase: {
        styleOverrides: {
          root: {
            fontSize: '12px',
          },
          input: {
            fontSize: '12px',
            padding: '6px 10px',
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          input: {
            fontSize: '12px',
            padding: '6px 10px',
          },
        },
      },
      // Table styling for compact display
      MuiTableCell: {
        styleOverrides: {
          root: {
            fontSize: '12px',
            padding: '4px 8px',
          },
        },
      },
      // Button styling
      MuiButton: {
        styleOverrides: {
          root: {
            fontSize: '12px',
          },
        },
      },
    },
  })

  export default theme